import React from 'react';

/**
 * 官方代币图标（SVG 复刻）：USDC / USDT / ETH / BNB / SOL
 * size 控制直径。
 */
const TokenIcon = ({ symbol, size = 24 }) => {
  const common = { width: size, height: size, viewBox: '0 0 32 32', style: { flexShrink: 0 } };

  switch (symbol.toUpperCase()) {
    case 'USDC':
      return (
        <svg {...common}>
          <circle cx="16" cy="16" r="16" fill="#2775CA" />
          <path d="M19.5 19.5c0-2-1.5-2.7-4.5-3.1-2.5-.3-3.2-.8-3.2-1.8 0-.9.8-1.5 2.2-1.5 1.3 0 2.1.4 2.4 1.4.1.2.3.4.5.4h1.3c.3 0 .5-.2.5-.5v-.1c-.3-1.6-1.5-2.6-3.2-2.8V9.5c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5v2c-1.9.3-3.2 1.6-3.2 3.2 0 2 1.5 2.6 4.5 3 2.4.3 3.2.9 3.2 1.9 0 1-.9 1.6-2.3 1.6-1.4 0-2.3-.6-2.5-1.6-.1-.2-.3-.4-.5-.4h-1.4c-.3 0-.5.2-.5.5 0 .1 0 .2.1.3.4 1.7 1.6 2.8 3.6 3v2c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-2c1.9-.3 3.2-1.6 3.2-3.3z" fill="#fff" />
          <path d="M12.9 24.6c-4.2-1.6-6.3-6.2-4.7-10.4.8-2.1 2.5-3.7 4.7-4.4.2-.1.4-.3.4-.6v-1.3c0-.3-.2-.5-.5-.5-.1 0-.2 0-.3.1-3.1 1.1-5.3 3.3-6.2 6.4-1.8 5.7 1.3 11.8 7 13.6.3.1.6 0 .8-.2.2-.2.2-.5.1-.7l-.7-2c-.2-.2-.4-.3-.6-.2zm11-16.8c-.3-.1-.6 0-.8.2-.2.2-.2.5-.1.7l.7 2c.1.3.3.4.6.4 4.2 1.6 6.3 6.2 4.7 10.4-.8 2.1-2.5 3.7-4.7 4.4-.2.1-.4.3-.4.6v1.3c0 .3.2.5.5.5.1 0 .2 0 .3-.1 3.1-1.1 5.3-3.3 6.2-6.4 1.8-5.6-1.3-11.7-7-13.5z" fill="#fff" />
        </svg>
      );
    case 'USDT':
      return (
        <svg {...common}>
          <circle cx="16" cy="16" r="16" fill="#26A17B" />
          <path d="M17.6 17.5v-2.6c3.4-.2 5.9-.9 5.9-1.8 0-.9-2.6-1.7-5.9-1.9V8.7h4.6V6.2H9.8v2.5h4.6v2.5c-3.3.2-5.9 1-5.9 1.9s2.6 1.7 5.9 1.8v2.6c-4.8-.2-8.4-1.2-8.4-2.4 0-1 2.7-1.9 6.4-2.2v2.7c.1 0 .3 0 .4 0s.3 0 .4 0v-2.7c3.7.3 6.4 1.2 6.4 2.2 0 1.2-3.6 2.2-8.4 2.4zm0-7.1h.3c3.9 0 6.6.8 6.6 1.7 0 .9-2.7 1.6-6.6 1.7v-3.4h-.3zm-.3 8.2v-3.2c-.1 0-.2 0-.3 0s-.2 0-.3 0v3.2c-4-.2-6.9-1-6.9-2 0-1.1 2.9-1.9 6.9-2zm0 0" fill="#fff" />
        </svg>
      );
    case 'ETH':
      return (
        <svg {...common}>
          <circle cx="16" cy="16" r="16" fill="#627EEA" />
          <path d="M15.9 5l5.1 8.4-5.1 3-5.2-3L15.9 5zm0 9.8l5.1-1.4L15.9 27l-5.2-13.6 5.2 1.4zm0 3.4l-3.5-1.4 3.5 4.9 3.4-4.9-3.4 1.4z" fill="#fff" />
        </svg>
      );
    case 'BNB':
      return (
        <svg {...common}>
          <circle cx="16" cy="16" r="16" fill="#F3BA2F" />
          <path d="M11.8 14.4l4.2-4.2 4.2 4.2 2.4-2.4-6.6-6.6-6.6 6.6 2.4 2.4zM6 17.2l2.4-2.4 2.4 2.4-2.4 2.4L6 17.2zm5.8 0l4.2 4.2 4.2-4.2 2.4 2.4-6.6 6.6-6.6-6.6 2.4-2.4zm11.8 0l2.4-2.4 2.4 2.4-2.4 2.4-2.4-2.4zM11.8 17.2h.1l-.1.1 2.4 2.4 2.4-2.4v-.1l.1-.1.1-.1 2.4-2.4-2.4-2.4-2.4 2.4h-.2l-2.4 2.4 2.4 2.4z" fill="#fff" />
        </svg>
      );
    case 'SOL':
      return (
        <svg {...common}>
          <circle cx="16" cy="16" r="16" fill="#111" />
          <linearGradient id="solg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#9945FF" />
            <stop offset="100%" stopColor="#14F195" />
          </linearGradient>
          <path d="M10.3 19.6c.2-.2.5-.3.8-.3h13.6l-3.1 3.1c-.2.2-.5.3-.8.3H7.2l3.1-3.1z" fill="url(#solg)" />
          <path d="M10.3 8.6c.2-.2.5-.3.8-.3h13.6l-3.1 3.1c-.2.2-.5.3-.8.3H7.2l3.1-3.1z" fill="url(#solg)" />
          <path d="M20.6 14.1c.2-.2.5-.3.8-.3H25l-2.1 2.1h-9.5l7.2-1.8z" fill="url(#solg)" opacity="0.7" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="16" cy="16" r="16" fill="#6e6e73" />
          <text x="16" y="21" textAnchor="middle" fontSize="14" fill="#fff" fontWeight="700" fontFamily="inherit">$</text>
        </svg>
      );
  }
};

export default TokenIcon;
